import {
  RenderDeliveryOrder,
  RenderPurchaseOrder,
  RenderSalesOrder,
  RenderTripOrder,
  RenderCashSales,
  RenderRetailCashSales,
  RenderRetailPrescription,
  RenderItemTransfer,
  RenderItemReceive,
  // RenderRetailItemReceive,
  RenderSalesCreditNote,
  RenderSalesDebitNote,
  RenderPurchaseReturn,
  RenderReplacementDelivery,
  RenderItemRelocate,
  RenderItemTransform,
  RenderItemIssue,
  RenderStockTake,
  RenderPurchaseInvoice,
  RenderTransferReturn,
  RenderTransferRequisition,
  RenderItemAdjustment,
  RenderSalesInvoice,
  RenderPickOrder,
} from './document';

import { RenderPackageLabel } from './repository';
// import { RenderQueueLabel } from '../../customization/pengchu/template/pdf/queue/index';

const defaultPropsDocument = {
  pageSizeOptions: ['A4'],
  pageOrientationOptions: [],
  renderDataTypes: [],
};

/*
 * @for document trip / pick order
 */
const defaultPropsDocument2 = {
  pageSizeOptions: ['A4'],
  pageOrientationOptions: [],
  renderDataTypes: ['Document', 'Items By Document', 'Items By Location'],
};

const defaultPropsRepository = {
  pageSizeOptions: [],
  pageOrientationOptions: [],
  renderDataTypes: ['6x6', '10x10'],
};

export const documentTypes = {
  deliveryOrder: {
    id: 'deliveryOrder',
    ...defaultPropsDocument,
    RenderFunction: RenderDeliveryOrder,
  },
  salesOrder: {
    id: 'salesOrder',
    ...defaultPropsDocument,
    RenderFunction: RenderSalesOrder,
  },
  purchaseOrder: {
    id: 'purchaseOrder',
    ...defaultPropsDocument,
    RenderFunction: RenderPurchaseOrder,
  },
  tripOrder: {
    id: 'tripOrder',
    ...defaultPropsDocument,
    RenderFunction: RenderTripOrder,
  },
  cashSales: {
    id: 'cashSales',
    ...defaultPropsDocument,
    RenderFunction: RenderCashSales,
  },
  itemTransfer: {
    id: 'itemTransfer',
    ...defaultPropsDocument,
    RenderFunction: RenderItemTransfer,
  },
  itemReceive: {
    id: 'itemReceive',
    ...defaultPropsDocument,
    RenderFunction: RenderItemReceive,
  },
  salesCreditNote: {
    id: 'salesCreditNote',
    ...defaultPropsDocument,
    RenderFunction: RenderSalesCreditNote,
  },
  salesDebitNote: {
    id: 'salesDebitNote',
    ...defaultPropsDocument,
    RenderFunction: RenderSalesDebitNote,
  },
  purchaseReturn: {
    id: 'purchaseReturn',
    ...defaultPropsDocument,
    RenderFunction: RenderPurchaseReturn,
  },
  replacementDelivery: {
    id: 'replacementDelivery',
    ...defaultPropsDocument,
    RenderFunction: RenderReplacementDelivery,
  },
  itemRelocate: {
    id: 'itemRelocate',
    ...defaultPropsDocument,
    RenderFunction: RenderItemRelocate,
  },
  itemTransform: {
    id: 'itemTransform',
    ...defaultPropsDocument,
    RenderFunction: RenderItemTransform,
  },
  itemIssue: {
    id: 'itemIssue',
    ...defaultPropsDocument,
    RenderFunction: RenderItemIssue,
  },
  stockTake: {
    id: 'stockTake',
    ...defaultPropsDocument,
    RenderFunction: RenderStockTake,
  },
  packageLabel: {
    id: 'packageLabel',
    ...defaultPropsRepository,
    RenderFunction: RenderPackageLabel,
  },
  purchaseInvoice: {
    id: 'purchaseInvoice',
    ...defaultPropsDocument,
    RenderFunction: RenderPurchaseInvoice,
  },
  transferReturn: {
    id: 'transferReturn',
    ...defaultPropsDocument,
    RenderFunction: RenderTransferReturn,
  },
  transferRequisition: {
    id: 'transferRequisition',
    ...defaultPropsDocument,
    RenderFunction: RenderTransferRequisition,
  },
  itemAdjustment: {
    id: 'itemAdjustment',
    ...defaultPropsDocument,
    RenderFunction: RenderItemAdjustment,
  },
  retailCashSales: {
    id: 'retailCashSales',
    ...defaultPropsDocument,
    RenderFunction: RenderRetailCashSales,
  },
  retailPrescription: {
    id: 'retailPrescription',
    ...defaultPropsDocument,
    RenderFunction: RenderRetailPrescription,
  },
  salesInvoice: {
    id: 'salesInvoice',
    ...defaultPropsDocument,
    RenderFunction: RenderSalesInvoice,
  },
  pickOrder: {
    id: 'pickOrder',
    ...defaultPropsDocument2,
    RenderFunction: RenderPickOrder,
  },

  // queueLabel: {
  //   id: 'queueLabel',
  //   ...defaultPropsDocument,
  //   RenderFunction: RenderQueueLabel,
  // },

  // retailItemReceive: {
  //     id: "retailItemReceive",
  //     ...defaultPropsDocument,
  //     RenderFunction: RenderRetailItemReceive,
  // },
};
